import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GamesSharedModule } from '@games/games-shared/games-shared.module';
import { AnswerEntryFormComponent } from '@new-core/components/inputs-gi/answer-entry-form/answer-entry-form.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { FitTextModule, FormFieldModule, TextsFilterComponent } from '@shared/components/games';
import { FlashReadingControllerComponent } from './flash-reading-controller/flash-reading-controller.component';
import { FlashReadingCorrectAnswerPreviewComponent } from './flash-reading-preview/flash-reading-answer-preview/flash-reading-answer-preview.component';
import { FlashReadingExamplePreviewComponent } from './flash-reading-preview/flash-reading-example-preview/flash-reading-example-preview.component';
import { FlashReadingParametersPreviewComponent } from './flash-reading-preview/flash-reading-parameters-preview/flash-reading-parameters-preview.component';
import { FlashReadingUserAnswerPreviewComponent } from './flash-reading-preview/flash-reading-user-answer-preview/flash-reading-user-answer-preview.component';
import { FlashReadingSettingsComponent } from './flash-reading-settings/flash-reading-settings.component';
import { GameInputComponent } from '@new-core/components/inputs-gi/game-input/game-input.component';

@NgModule({
  declarations: [
    FlashReadingControllerComponent,
    FlashReadingSettingsComponent,
    FlashReadingCorrectAnswerPreviewComponent,
    FlashReadingExamplePreviewComponent,
    FlashReadingParametersPreviewComponent,
    FlashReadingUserAnswerPreviewComponent,
  ],
  exports: [
    FlashReadingControllerComponent,
    FlashReadingSettingsComponent,
    FlashReadingCorrectAnswerPreviewComponent,
    FlashReadingExamplePreviewComponent,
    FlashReadingParametersPreviewComponent,
    FlashReadingUserAnswerPreviewComponent,
    NgSelectModule,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    FitTextModule,
    NgSelectModule,
    FormFieldModule,
    TextsFilterComponent,
    GamesSharedModule,
    AnswerEntryFormComponent,
    GameInputComponent,
  ],
})
export class FlashReadingModule {}
